module.exports = __webpack_public_path__ + "assets/52af5e88f0ebcf42f1b33c40e8488947.mp3";